import React from "react";

import { elementConstants } from "../../constants/cms/form/element/element.constants";

import Question from "../elements/element/Question/Question";
import Field from "../elements/element/Field/Field";
import ProfileImageUploader from "../elements/element/ProfileImageUploader/ProfileImageUploader";
import Event from "../elements/element/Event/Event";
import Container from "../elements/element/Container/Container";
import Content from "../elements/element/Content/Content";
import PaymentOptions from "../elements/element/PaymentOptions/PaymentOptions";
import UserPage from "../elements/element/UserPage/UserPage";
import PreConfirmation from "../elements/element/PreConfirmation/PreConfirmation";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import Discount from "../elements/element/Discount/Discount";
import GroupRegistration from "../elements/element/GroupRegistration/GroupRegistration";
import  FileUploader from "../elements/element/FileUploader/FileUploader";

export const renderElement = (type, element, dropControl, parentTransform, getValidator, updateValidator, allowAdd) => {
  switch (type) {
    case elementConstants.DELETED:
      return (
        <div className="deleted-element-placeholder">
          <div className="label">
            {element.type == elementConstants.EVENT ? <SystemLabel name="DeletedEvent" /> : null}
            {element.type == elementConstants.QUESTION ? <SystemLabel name="DeletedQuestion" /> : null}
            {element.type == elementConstants.FIELD ? <SystemLabel name="DeletedField" /> : null}
            {element.type == elementConstants.CONTENT ? <SystemLabel name="DeletedContent" /> : null}
            {element.type == elementConstants.CONTAINER ? <SystemLabel name="DeletedContainer" /> : null}
            {element.type == elementConstants.USER_PAGE ? <SystemLabel name="DeletedUserPage" /> : null}
          </div>
          <div className="sublabel">
            <SystemLabel name="DeleteThisElement" />
          </div>
        </div>
      );
    case elementConstants.EVENT:
      return <Event element={element} getValidator={getValidator} updateValidator={updateValidator} />;
    case elementConstants.FIELD:
      return <Field element={element} getValidator={getValidator} updateValidator={updateValidator} />;
    case elementConstants.QUESTION:
      return <Question element={element} getValidator={getValidator} updateValidator={updateValidator} />;
    case elementConstants.CONTAINER:
      return <Container element={element} getValidator={getValidator} updateValidator={updateValidator} disableDropParent={dropControl} parentTransform={parentTransform} />;
    case elementConstants.CONTENT:
      return <Content element={element} />;
    case elementConstants.PROFILEIMAGE_UPLOAD:
      return <ProfileImageUploader settings={element.data} element={element} />;
    case elementConstants.PAYMENT_OPTIONS:
      return <PaymentOptions element={element} getValidator={getValidator} updateValidator={updateValidator} />;
    case elementConstants.USER_PAGE:
      return <UserPage element={element} />;
    case elementConstants.PRE_CONFIRMATION:
      return <PreConfirmation element={element} />;
    case elementConstants.DISCOUNT:
      return <Discount element={element} />;
    case elementConstants.GROUP_REGISTRATION:
      return <GroupRegistration allowAdd={allowAdd} element={element} />;
    case elementConstants.FILE_UPLOADER:
      return <FileUploader element={element} />;
    default:
      return null;
  }
};
